import { Record } from 'immutable';
import { RoomCommissionType } from './room-commission-type';

const RoomCommissionSummaryRecord = Record({
  /**
   * Total Spend in the payment summary card does not consider if shoulder dates should be excluded.
   */
  totalSpend: null,
  /**
   * Comm Rate in the payment summary card is the commission percentage
   */
  commRate: null,
  /**
   * The result of applying the commission percentage to the commissionable revenue.
   * In the case of reservations and RSVPs, it considers if shoulder dates should be excluded.
   */
  amountDue: null,

  roomCommissionType: null,
  shoulderDatesExcluded: null,
  totalNights: null,
  avgRoomRate: null
});

export class RoomCommissionSummary extends RoomCommissionSummaryRecord {
  /**
   * Total Spend in the payment summary card does not consider if shoulder dates should be excluded.
   */
  totalSpend: number;
  /**
   * Comm Rate in the payment summary card is the commission percentage
   */
  commRate: number;
  /**
   * The result of applying the commission percentage to the commissionable revenue.
   * In the case of reservations and RSVPs, it considers if shoulder dates should be excluded.
   */
  amountDue: number;

  roomCommissionType: RoomCommissionType;
  shoulderDatesExcluded: boolean;
  totalNights: number;
  avgRoomRate: number;
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/room-commission-summary.ts